/** @jsxImportSource @emotion/react */
import { Global, Theme } from "@emotion/react";
import { Outlet } from "react-router-dom";

const divCSS = (theme: Theme) => ({
  background: [theme.colors.pink, theme.gradients.radial1],
  display: "flex",
  flexDirection: "column" as const,
  justifyContent: "center",
  alignItems: "center",
  minHeight: "100vh",
  padding: "1rem",
});

const globalCSS = (theme: Theme) => ({
  "html,body": {
    background: theme.colors.pink,
  },
});

function LayoutFull() {
  return (
    <div css={divCSS} data-testid="LayoutFull">
      <Global styles={globalCSS} />
      <Outlet />
    </div>
  );
}

export { LayoutFull };
